import { render } from "./ImageUploadModal.vue?vue&type=template&id=790f6966"
import script from "./ImageUploadModal.vue?vue&type=script&lang=js"
export * from "./ImageUploadModal.vue?vue&type=script&lang=js"
script.render = render

export default script